
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { save, update, getIsSupportScan } from '@/api/device'
import { getAllStore as getAllStoreList } from '@/api/common'
import { getDeviceTypeList, getDeviceTypeByParentId, getDeviceSubTypeList, getSubDeviceTypeList } from '@/api/deviceType'
import UploadImg from '@/components/uploadImg.vue'
import deepCopy from '@/utils/deepCopy'
import dayjs from 'dayjs'
import { isNumberOrNumericString } from '@/utils/common'

interface Device {
    id?: number
    deviceName?: string
    deviceClassName?: string
    deviceNameId?: string
    deviceClassId?: string
    deviceTypeId?: number
    deviceCode?: string
    storeId?: string
    storeName?: string
    storeShowName?: string
    runtime?: number
    remark?: string
    expireTime?: string
    deviceImg?: any[]
    protocolType?: number
    isNoScan?: boolean
    envDisable?: boolean
    deviceCategory?: number
    noAutoDirection?: number
    specificEnv?: number
    photoDirection?: number
    photoType?: number
}

const initFormData = {
    deviceNameId: '',
    deviceTypeId: '',
    deviceClassId: "",
    deviceCode: '',
    protocolType: 0,
    isNoScan: false,
    envDisable: false,
    storeId: '',
    runtime: '',
    remark: '',
    deviceImg: [],
    deviceCategory: 0,
    noAutoDirection: 0,
    specificEnv: 0,
    photoDirection: 0,
    photoType: 0,
}

@Component({ name: 'h5-device-edit',
    components: { UploadImg }
})
export default class H5DeviceEdit extends Vue {
    formData: Device = {};
    deviceTypeList: any[] = []
    deviceSubTypeList: any[] = []
    formDeviceCategoryOptions: any[] = []
    allStoreList: any[] = []
    isSupportScan = false
    submitting = false
    isEdit = false

    protocolTypeOptions = [
        { label: 'MQTT', value: 0 },
        { label: '天力能API', value: 1 }
    ]

    tongueShoot = [
        { label: '全局拍摄', value: 0 },
        { label: 'H5截屏', value: 1 },
        { label: '原生相机', value: 2 }
    ]

    tongueRotate = [
        { label: '0度', value: 0 },
        { label: '90度', value: 1 },
        { label: '180度', value: 2 },
        { label: '270度', value: 3 },
        { label: '360度', value: 4 }
    ]

    rules = {
        deviceTypeId: [{ required: true, message: '请选择设备类型', trigger: 'change' }],
        deviceClassId: [{ required: true, message: '请选择设备分类', trigger: 'change' }],
        deviceNameId: [{ required: true, message: '请选择关联设备', trigger: 'change' }],
        protocolType: [{ required: true, message: '请选择协议类型', trigger: 'change' }],
        isNoScan: [{ required: true, type: 'boolean', message: ' ', trigger: 'change' }],
        storeId: [{ required: true, message: '请选择关联门店', trigger: 'change' }],
        deviceCategory: [{ required: true, message: '请选择机器类别' }],
        noAutoDirection: [{ required: true, message: '请选择是否拍照自动翻转' }],
        specificEnv: [{ required: true, message: '请选择具体环境' }],
        photoType: [{ required: true, message: '请选择拍摄方式' }],
        photoDirection: [{ required: true, message: '请选择拍摄反转角度' }]
    }

    mounted() {
        this.getDeviceType()
        this.getAllStoreList()
        this.getDeviceTypeByParentId();
        this.initData()
    }

    initData() {
        const deviceData = this.$route.params.deviceData
        if (deviceData) {
            this.isEdit = true
            const device = JSON.parse(decodeURIComponent(deviceData))
            this.formData = {
                id: device.id,
                deviceName: device.deviceName,
                deviceClassId: device.deviceClassId || '',
                deviceNameId: device.deviceNameId || '',
                deviceTypeId: device.deviceTypeId || '',
                deviceCode: device.deviceCode || '',
                storeId: device.storeId || '',
                storeShowName: device.storeShowName || '',
                runtime: device.runtime || '',
                remark: device.remark || '',
                deviceImg: device.deviceImg || [],
                protocolType: device.protocolType || 0,
                isNoScan: Boolean(device.isNoScan),
                envDisable: Boolean(device.envDisable),
                deviceCategory: device.deviceCategory || 0,
                noAutoDirection: device.noAutoDirection || 0,
                specificEnv: device.specificEnv || 0,
                photoDirection: device.photoDirection || 0,
                photoType: device.photoType || 0
            }

            // 如果是编辑，需要设置一些额外的数据
            if (device.deviceClassId) {
                this.formDeviceCategoryOptions = [{ id: device.deviceClassId, deviceClassName: device.deviceClassName }]
            }
            if (device.deviceNameId) {
                this.deviceSubTypeList = [{ id: device.deviceNameId, deviceName: device.deviceName }]

            }

            if (device.storeId) {
                this.allStoreList = [{ id: device.storeId, storeName: device.storeName, storeId: device.storeId, storeShowName: device.storeShowName }]
            }
        } else {

            this.isEdit = false
            console.log('this.$route.params.deviceData', this.$route.params.deviceData)
            this.formData = deepCopy(initFormData)
            console.log('initFormData', this.formData)
        }
    }

    goBack() {
        this.$router.go(-1)
    }

    async getDeviceType(str = '') {
        if (typeof str === 'object') str = ''
        try {
            const res = await getDeviceTypeList({})
            this.deviceTypeList = res.data || []
        } catch (error) {
            console.error('获取设备类型失败', error)
        }
    }

    getSubDeviceTypeList(key: string, parentId: string | number) {
        if (!parentId) return
        getSubDeviceTypeList({ parentId }).then((res) => {
            this[key] = res.data || []
        }).catch(() => {
            this[key] = []
        })
    }

    deviceTypeChange(event: any) {
        if (!event) return
        this.formData.deviceClassId = ''
        this.formData.deviceNameId = ''
    }

    formDeviceClassNameChange(event: any) {
        if (!event) return
        this.formData.deviceNameId = ''
    }

    getDeviceTypeByParentId() {
        if (this.formData.deviceTypeId) {
            getDeviceTypeByParentId({
                mainTypeId: this.formData.deviceTypeId,
                subTypeId: this.formData.deviceClassId
            }).then((res) => {
                this.deviceSubTypeList = res.data || []
            }).catch((err) => {
                console.error('获取设备子类型失败', err)
            })
        } else {
            getDeviceSubTypeList({}).then((res) => {
                this.deviceSubTypeList = res.data || []
            }).catch((err) => {
                console.error('获取设备子类型失败', err)
            })
        }
    }

    async getAllStoreList(str = '') {
        if (typeof str === 'object') str = ''
        try {
            const res = await getAllStoreList({ storeName: str })
            if (res.data) {
                res.data.forEach((el: any) => el.id = el.storeId)
                this.allStoreList = res.data
            }
        } catch (error) {
            console.error('获取门店列表失败', error)
        }
    }

    storeChange(event: any) {
        const store = this.allStoreList?.find((el: any) => el.storeId === event)
        this.formData.storeShowName = store?.storeShowName || ''
    }

    getSubType(subTypeObject: any) {
        return subTypeObject.deviceName + '[' + subTypeObject.runtime + '分钟]'
    }

    async handleSubmit() {
        try {
            await (this.$refs.validateForm as any).validate()
            await this.confirmSubmit()
        } catch (error) {
            console.error('表单验证失败', error)
        }
    }

    async confirmSubmit() {
        this.submitting = true
        try {
            // 准备提交数据
            const submitData = {
                ...this.formData,
                deviceName: this.getName(this.deviceSubTypeList, this.formData.deviceNameId, 'id', 'deviceName'),
                deviceTypeName: this.getName(this.deviceTypeList, this.formData.deviceTypeId, 'id', 'deviceName'),
                storeName: this.getName(this.allStoreList, this.formData.storeId, 'id', 'storeName'),
                isNoScan: Number(this.formData.isNoScan),
                envDisable: Number(this.formData.envDisable),
                deviceImg: this.formData.deviceImg?.map((img: any, index: number) => ({
                    sort: index,
                    deviceId: this.formData.id,
                    url: img.url
                })) || []
            }

            // 检查免扫码和环境禁用
            const scanFlag = this.checkScanFlag()
            const disableFlag = this.checkDisableFlag()

            let confirmMessage = ''
            if (scanFlag && disableFlag) {
                confirmMessage = '确认打开免扫码开关，并且在当前环境禁用该设备？'
            } else if (scanFlag) {
                confirmMessage = '确认打开免扫码开关？'
            } else if (disableFlag) {
                confirmMessage = '确认该设备当前环境禁用？'
            }

            if (confirmMessage) {
                await this.$confirm(confirmMessage, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true,
                })
            }

            if (this.isEdit) {
                await update(submitData)
                this.$message.success('编辑成功')
            } else {
                await save(submitData)
                this.$message.success('新增成功')
            }

            this.goBack()
        } catch (error) {
            if (error !== 'cancel') {
                console.error('提交失败', error)
                this.$message.error('操作失败')
            }
        } finally {
            this.submitting = false
        }
    }

    checkScanFlag() {
        return this.formData.isNoScan === true
    }

    checkDisableFlag() {
        return this.formData.envDisable === true
    }

    getName(target: any[], id: any, keyId: string, keyName: string) {
        const item = target.find(item => item[keyId] === id)
        return item ? item[keyName] : ''
    }

    @Watch('formData.deviceNameId')
    setSubType(deviceNameId: string, oldDeviceNameId: string) {
        setTimeout(() => {
            if (oldDeviceNameId || !this.formData.runtime) {
                const device = this.deviceSubTypeList.find(val => val.id === deviceNameId)
                if (device) {
                    this.formData.runtime = device.runtime
                }
            }
            if (!deviceNameId || !isNumberOrNumericString(deviceNameId)) return

            getIsSupportScan({ deviceNameId }).then((res) => {
                this.isSupportScan = Boolean(res.data)
                if (!this.isSupportScan) {
                    this.formData.isNoScan = false
                }
            }).catch((err) => {
                console.error('获取免扫码支持状态失败', err)
            })
        }, 500);


    }
}
